var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat-color-icons:mind-map"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.3999 23L38.5999 19L25.9999 21.6V8H21.9999V20.3L8.0999 11.3L5.8999 14.7L21.0999 24.5L9.3999 39.8L12.5999 42.2L23.8999 27.4L32.2999 40.1L35.6999 37.9L27.2999 25.4L39.3999 23Z",
    fill: "#CFD8DC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24 31C27.866 31 31 27.866 31 24C31 20.134 27.866 17 24 17C20.134 17 17 20.134 17 24C17 27.866 20.134 31 24 31Z",
    fill: "#3F51B5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24 13C26.7614 13 29 10.7614 29 8C29 5.23858 26.7614 3 24 3C21.2386 3 19 5.23858 19 8C19 10.7614 21.2386 13 24 13Z",
    fill: "#00BCD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M39 26C41.7614 26 44 23.7614 44 21C44 18.2386 41.7614 16 39 16C36.2386 16 34 18.2386 34 21C34 23.7614 36.2386 26 39 26Z",
    fill: "#00BCD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7 18C9.76142 18 12 15.7614 12 13C12 10.2386 9.76142 8 7 8C4.23858 8 2 10.2386 2 13C2 15.7614 4.23858 18 7 18Z",
    fill: "#00BCD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11 46C13.7614 46 16 43.7614 16 41C16 38.2386 13.7614 36 11 36C8.23858 36 6 38.2386 6 41C6 43.7614 8.23858 46 11 46Z",
    fill: "#00BCD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M34 44C36.7614 44 39 41.7614 39 39C39 36.2386 36.7614 34 34 34C31.2386 34 29 36.2386 29 39C29 41.7614 31.2386 44 34 44Z",
    fill: "#00BCD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.cd445af3851cca1441edfb5f6e7b9ee7.svg";
export { ForwardRef as ReactComponent };